export const AUTH_TTL_SECONDS = 10 * 60;

/**
 * Zone for the customer's "today" when the browser sends no usable IANA
 * zone. Washington Gas serves DC, Maryland and Virginia, so Eastern is the
 * customer's zone in practice.
 */
export const CUSTOMER_TIME_ZONE = "America/New_York";

/**
 * Days the slot picker shows: the availability search queries SAP until it
 * has this many days with a bookable window (or reaches the horizon) and
 * never returns more.
 */
export const OFFERED_DAYS = 3;

/** How far past today the availability search may reach, in days. */
export const AVAILABILITY_HORIZON_DAYS = 60;
